
export const ROUTE_PATHS = {
   HOME: '/',
   LOGIN: '/login',
   REGISTER: '/register',
   VERIFY_OTP: '/verify-otp',
   DASHBOARD: '/dashboard',
   ACCOUNT: '/account',
   Baseline: '/baseline',
   DOCUMENTS: '/documents',
   StatusPage:'/status',
   INVOICE: '/invoice',
   ADDITIONAL_DATA: '/additional-data',
   CHANGE_PASSWORD: '/change-password',
   LOGOUT: '/logout',
   LOGOUT_ALL: '/logout-all',
   BLOGS: '/blogs',
   BLOG_DETAIL: '/blogs/:slug',
   RegistrationSuccess:"/registration-success",
   ForgetPassword:"/forgetpassword",
   OurLocations:'/our-locations',
   SCMart:'/scmart',
   APPLY:'/apply/:slug',
   // Static pages
   TERMS: '/terms-and-conditions',
   PRIVACY: '/privacy-policy',
   CONTACT: '/contact-us',
   CAREERS: '/careers',
   COOKIE_POLICY: '/cookie-policy',
   FAQ: '/faq',
   GENERAL_TERMS: '/general-terms',
   DATA_SECURITY: '/data-security',
   INFORMATION_SECURITY: '/information-security',
   RESEARCH: '/research-and-discovery',
   ProductOverview : '/product-overview',
   OurEngagements : '/our-engagements',
   RealTimeData :'/real-time-data',
   // Project routes
   REQUEST_DEMO: '/request-demo',
   RENEWABLE_ENERGY: '/renewable-energy',
   WASTE_MANAGEMENT: '/waste-management',
   PLASTIC_ALTERNATIVES: '/plastic-alternatives',
   Agriculture :'/agriculture',
   AgriculturalProjects:'/agriculture-projects',
   IndustrialProcessprojects:'/industrial-process-projects',
   IndustrialProcess:'/industrial-process',
   RENEWABLE_PROJECTS: '/renewable-energy-projects',
   WASTE_PROJECTS: '/waste-management-projects',
   PLASTIC_PROJECTS: '/plastic-alternatives-projects',
   AccountRequest:'/send-request-account',
   ContactSupport:'/contact-support',
   Forestry:'/forestry',
   ForestryProjects:'/forestry-projects',
   ProjectVerification:'/project-verification',
   BoundarySelectionPage:'/boundary-selection',
   // Accounts Sub Tabs path creations
   carboncredits:'/account/carbon-credits',
   StakeholderEngagement:'/account/stakeholder-engagement',
   FinancialAnalysis:'/financial-analysis',
   EmissionCalculations:'/emission-calculations',

   ProjectReport:'/Project-report',
   // Financial Analysis Sub Tabs
   PLAnalysis:'financial-analysis/pl-analysis',
   SensitivityAnalysis:'financial-analysis/sensitivity-analysis',
   AditionalityAnalysis:'financial-analysis/aditionality-analysis',

   ForestryDashboard:'newdashboard',
}; 